/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Button } from "@nordcloud/gnui";
import { BreadcrumbsBox } from "../../components";

export function SettingsPage() {
  // TODO: Remove sample tags
  const tags = [
    {
      color: "success",
      text: "success",
    },
  ];

  return (
    <BreadcrumbsBox tags={tags}>
      <Button>Primary action</Button>
    </BreadcrumbsBox>
  );
}
